import logo from './logo.svg';
import React from "react"
import $ from "jquery"
import { Whisper, Tooltip, Popover, Form } from "rsuite"
import { SchemaModel, StringType, DateType, NumberType, ObjectType, ArrayType } from 'schema-typed';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'


import 'bootstrap/dist/css/bootstrap.min.css';
import 'rsuite/dist/rsuite.min.css'
import "./libs/fontawesome-free-6.1.1-web/css/all.css"
import './App.css';


function App() {
  const NOMBRE_EMPRESA = process.env.REACT_APP_NOMBRE_EMPRESA
  const URL_LOGO = process.env.REACT_APP_URL_LOGO
  const API_URL = process.env.REACT_APP_API_URL
  const ASESORES = process.env.REACT_APP_ASESORES
    ? process.env.REACT_APP_ASESORES.split(";").map(asesor => ({ nombre: asesor }))
    : []
  const ESTADOS = {
    vacio: {
      mensaje: "Debe llenar los campor.",
      estilo: {
        color: "#804040",
        backgroundColor: "#ffc0c0",
      },
    },
    invalido: {
      mensaje: "Llene los campos correctamente.",
      estilo: {
        color: "#804040",
        backgroundColor: "#ffc0c0",
      },
    },
    espere: {
      mensaje: "Espere por favor",
      estilo: {
        color: "#806040",
        backgroundColor: "#ffe0c0",
      },
    },
    ok: {
      mensaje: "¡Gracias por su interés!",
      estilo: {
        color: "#408040",
        backgroundColor: "#c0ffc0",
      },
    },
    error: {
      mensaje: "Error. Vuelva a intentarlo más tarde.",
      estilo: {
        color: "#804040",
        backgroundColor: "#ffc0c0",
      },
    },
    // Prevenir errores por valor nulo
    "": {
      mensaje: "",
      estilo: {
        color: "#404040",
        backgroundColor: "#c0c0c0",
      },
    },
  }

  React.useState(() => {
    console.log(URL_LOGO)
  }, [])

  const [ intentos, setIntento ] = React.useState(0)
  const [ estado, setEstado ] = React.useState("vacio")
  const [ datos, _setDatos ] = React.useState({
    customer: {
      name: "",
      phoneNumber: "",
    },
    asesor: "",
    empresa: NOMBRE_EMPRESA
  })
  const setDatos = (_datos) => {
    _setDatos(_datos)
    const resultadoValidacion = modeloValidación.check(_datos);
    if (resultadoValidacion.customer.hasError) {
      if (
        resultadoValidacion.customer.object.name?.errorMessage === "Requerido"
        && resultadoValidacion.customer.object.phoneNumber?.errorMessage === "Requerido"
      ) {
        setEstado("vacio")
      }
      else if (
        resultadoValidacion.customer.object.name.hasError
        || resultadoValidacion.customer.object.phoneNumber.hasError
      ) {
        setEstado("invalido")
      } 
    }
    else {
      setEstado("")
    }
  }
  const whisper = React.useRef()

  const modeloValidación = SchemaModel({
    customer: ObjectType().shape({
      name: StringType("Debe ser su nombre").isRequired("Requerido"),
      phoneNumber: NumberType("Número Celular").isRequired("Requerido"),
    }),
  })

  
  const iniciarChat = async (intentos__) => {
    let intentos_ = intentos__ || 0
    var phone = $("#phone").val()
    if (phone[0] === "0") {
      phone = `593${phone.substring(1)}`
    }

    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    var dataEncoded = JSON.stringify(datos);

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: dataEncoded,
      redirect: 'follow'
    };

    if (!["vacio", "invalido"].includes(estado)) {
      fetch(`${API_URL}/send_message_from_web`,
        requestOptions
      )
        .then(response => {
          if (!response.ok) {
            throw Error("Error de API")
          }
          return response.text()
        })
        .then(result => {
          setEstado("ok")
          mostrarMensaje()
          setIntento(0)
          intentos_ = 0
        })
        .catch(error => {
          console.log({ intentos: intentos })
          if (intentos__ < 3) {
            mostrarMensaje("espere")
            mostrarMensaje()
            setTimeout(() => {
              iniciarChat(intentos_+1)
              setIntento(intentos+1)
              intentos_ = intentos_+1
            }, 3000)
          } else {
            setEstado("error")
            mostrarMensaje()
          }
        })
    } else {
      mostrarMensaje();
    }

  }

  const mostrarMensaje = (_estado) => {
    // TODO Solamente desplegar el diálogo, no necesariamente modificar el estado.
    if (_estado)
      setEstado(_estado)
    whisper.current.open(250)
    setTimeout(() => {
      whisper.current.close(250)
    }, 4000);
  }

  React.useEffect(() => {
    console.log(process.env.REACT_APP_ASESORES)
  }, {})

  return (
    <div classNameName="App">
      <div className="widget m-1">
        <header className="px-3 py-1 text-center d-flex align-items-center">
          <span className="circulo rounded-circle text-center">
            <img className="rounded-circle align-middle text-center"
              src={URL_LOGO} width="50" 
              height="50" 
            />
          </span>
          <span>
            Iniciar chat con <b>{ NOMBRE_EMPRESA }</b>
          </span>
        </header>
        <main className="p-1 py-3">
          <Form onSubmit={iniciarChat}>
            <div className="form-floating rounded-2 mb-1">
              <input type="text" className="form-control" id="name" value={datos.name}
                onChange={event => setDatos({ ...datos, 
                  customer: { ...datos.customer, name: event.target.value } }
                )}
                autocomplete="off" placeholder='Su nombre' />
              <label for="name">Su nombre</label>
            </div>
            <div className="form-floating rounded-2 mb-1">
              <input type="text" className="form-control" id="phone" value={datos.phone}
                onChange={event => setDatos({ ...datos, 
                  customer: { ...datos.customer, phoneNumber: event.target.value } }
                )}
                autocomplete="off" placeholder='Su WhatsApp' />
              <label for="phone">Su WhatsApp</label>
            </div>
            {ASESORES.length  
              ?<div className="form-floating rounded-2 mb-1">
                <select type="text" className="form-control" id="asesor" value={datos.asesor}
                  onChange={event => setDatos({ ...datos, asesor: event.target.value })}
                  autocomplete="off"
                >
                  <option value="">{"<< Ninguno >>"}</option>
                  {ASESORES.map((asesor, i) => 
                    <option key={i} value={asesor.nombre}>{asesor.nombre}</option>)
                  }
                </select>
                <label for="asesor">Asesor preferido</label>
              </div>
              :[]
            }
            <Whisper ref={whisper} trigger="none" placement='bottom'
              speaker={
                <Popover style={ESTADOS[estado].estilo}>{ ESTADOS[estado].mensaje }</Popover>
              }
            >
              <button type="submit" id="enviar" 
                className={`btn ${
                    ["vacio", "invalido"].includes(estado) 
                    ? "btn-secondary" 
                    : "btn-success"
                  } my-2 w-100`
                }
                disabled={["vacio", "invalido"].includes(estado)}
              >
                <i className="fab fa-whatsapp fa-lg"></i>
                &nbsp;
                <span>Enviar</span>
              </button>
            </Whisper>
          </Form>
        </main>
        <footer>
          <span>
            Un Asesor lo contactará inmediatamente a su WhatsApp.
          </span>
        </footer>
      </div>
    </div>
  );
}

export default App;
